import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('au_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('au_token');
      localStorage.removeItem('au_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// CBS loan account numbers can contain forward slashes (e.g. "93/17") which
// break URL path routing. Replace "/" with "~" before encoding so the server
// can decode it back. Use this helper everywhere a LAN goes into a URL path
// or query string.
export function encodeLan(lan) {
  if (lan === null || lan === undefined) return '';
  return encodeURIComponent(String(lan).replace(/\//g, '~'));
}
